import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Connector picker route (`/integrations/connections/new`) — entry point for
 * "Add connection". Super-admin only, matching the connections management
 * page it's launched from.
 */
const ConnectionPickerPage = lazy(
  () => import('~/features/integrations/pages/connection-picker-page'),
);

const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/integrations/connections/new')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  const { sc } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectionPickerPage subsidiaryId={sc} />
    </Suspense>
  );
}
